/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';

export default class TopicsSection extends Component {
  @service
  strings;

  loadingStates = true;
}
